import { ModelDataType } from 'src/app/interfaces/model-data-type';

import { BaseModel } from './base-model';
import * as models from './index';
import { TradeSpecialtyCategory } from './index';
import { PrimaryTrade } from './primary-trade';

export class TradeCategory extends BaseModel {
  static override columnMap = new Map<
    string,
    { property: string; type: 'column'; dataType: ModelDataType }
  >();
  static override associationMap = new Map<
    string,
    { property: string; type: 'association'; model: string }
  >();
  static override aliasedColumnMap = new Map<
    string,
    { property: string; type: 'alias' }
  >();

  static TradeCategoryProperties: (
    | {
        property: keyof TradeCategory;
        type: 'column';
        dataType: ModelDataType;
      }
    | {
        property: keyof TradeCategory;
        type: 'alias';
      }
    | {
        property: keyof TradeCategory;
        type: 'association';
        model: string;
      }
  )[] = [
    { property: 'id', type: 'column', dataType: 'number' },
    { property: 'categoryName', type: 'column', dataType: 'string' },
    { property: 'createdAt', type: 'column', dataType: 'date' },
    { property: 'updatedAt', type: 'column', dataType: 'date' },

    { property: 'assignedTradeCount', type: 'alias' },

    { property: 'PrimaryTrades', model: 'PrimaryTrade', type: 'association' },
    {
      property: 'TradeSpecialtyCategory',
      model: 'TradeSpecialtyCategory',
      type: 'association'
    }
  ];

  static {
    TradeCategory.TradeCategoryProperties.forEach((propertyObject) => {
      const { property, type } = propertyObject;
      if (type === 'column') {
        TradeCategory.columnMap.set(property, propertyObject);
      }
      if (type === 'alias') {
        TradeCategory.aliasedColumnMap.set(
          property,
          propertyObject as { property: string; type: 'alias' }
        );
      }
      if (type === 'association') {
        TradeCategory.associationMap.set(
          property,
          propertyObject as {
            property: string;
            type: 'association';
            model: string;
          }
        );
      }
    });
  }

  constructor(TradeCategoryObject: Partial<TradeCategory>) {
    super();

    TradeCategory.TradeCategoryProperties.forEach((propertyObject) => {
      const { property } = propertyObject;
      const value = TradeCategoryObject[property];
      if (value !== undefined) {
        Object.assign(this, { [property]: value });
      }
    });
  }

  id?: number;
  categoryName?: string;
  createdAt?: Date;
  updatedAt?: Date;

  assignedTradeCount?: number;

  PrimaryTrades?: PrimaryTrade[];
  TradeSpecialtyCategory?: TradeSpecialtyCategory;
}
